export default __webpack_public_path__ + "static/media/Audio_2021_HTB600_EGEBGNGAGJ_Gallery_Image_3_210202.5fccc467.jpg";